import { currentType, suggestType, TYPE_TAILWIND } from '../issueType'
import type { Issue } from '../github'

// Muestra el chip de tipo aplicado al issue. Si todavía no tiene label semántico,
// renderiza el sugerido en gris/borde para indicar "pendiente de aplicar".
export function TypeBadge({ issue }: { issue: Issue }) {
  const applied = currentType(issue)
  if (applied) {
    return (
      <span
        data-testid={`type-applied-${issue.number}`}
        className={`px-1.5 py-0.5 rounded text-[10px] 4k:text-sm font-bold uppercase tracking-wider shrink-0 ${TYPE_TAILWIND[applied]}`}
      >
        {applied}
      </span>
    )
  }
  const sug = suggestType(issue)
  return (
    <span
      data-testid={`type-pending-${issue.number}`}
      className="px-1.5 py-0.5 rounded text-[10px] 4k:text-sm font-bold uppercase tracking-wider shrink-0 border border-zinc-700 text-zinc-500"
      title="Sin etiquetar todavía — WipHub lo aplicará en segundos"
    >
      {sug}…
    </span>
  )
}
